'use client';

import { Chevron } from '@ahamove/icons';

import { Note as NoteIcon } from '@ahamove/icons/order';
import { Button, Stack, Text, Title, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import CustomComponent from '@/components/modals/modal-custom-drawer';
import NoteContent from '@/components/modals/note-modal/note-content';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

export default function NationwideBookingNote() {
  const isMobile = useIsMobile();
  const tBooking = useTranslations('booking');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const { remarks, isLoadingStore } = useBookingStore((state) => state);

  return (
    <>
      <Button
        disabled={isLoadingStore}
        loading={isLoadingStore}
        fullWidth
        h="auto"
        radius="0"
        pl={{ base: rem(8), md: rem(12) }}
        py={{ base: rem(8), md: rem(12) }}
        onClick={() => {
          open();
        }}
        pr="md"
        variant="white"
        leftSection={<NoteIcon className="m-1 size-6 md:m-0 md:size-8" />}
        rightSection={<Chevron className="size-4 md:size-6" />}
        justify="space-between"
        styles={{
          label: {
            width: '100%',
          },
        }}
      >
        <Stack gap={rem(4)} ta="left">
          {remarks ? (
            <Text size="sm" fw={500} c="neutral.7">
              {remarks}
            </Text>
          ) : (
            <>
              <Title order={isMobile ? 6 : 4} c="neutral.7">
                {tBooking('note.note_title')}
              </Title>
            </>
          )}
        </Stack>
      </Button>
      <CustomComponent
        title={tBooking('note.note_title')}
        isOpen={isOpen}
        onClose={close}
        optionStyle={{
          headerStyle: {
            minHeight: rem(56),
            borderBottom: '1px solid var(--mantine-color-neutral-0)',
          },
        }}
      >
        <NoteContent onClose={close} />
      </CustomComponent>
    </>
  );
}
